import React from 'react';
import gql from "graphql-tag";

export interface ValidateLocationInterface {
  validateAddress: {
  code: string;
  message: string;
  success: boolean;
  }
}

export const VALIDATE_DISTANCE = gql`
    mutation location($address: String!) {
        validateAddress( address: $address )
        {
            success
            message
            code
        }
    }
`

